<template>
  <div class="rounded overflow-hidden">
    <n-skeleton class="rounded" height="25vh" width="100%" :sharp="false" />
  </div>
</template>
